var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 792",
    style: {
      enableBackground: "new 0 0 612 792"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#F5F7F7;}\n\t.st2{fill:#E2E2E2;}\n\t.st3{fill:#C4E0EC;}\n\t.st4{fill:#836180;}\n\t.st5{fill:#735372;}\n\t.st6{fill:#997998;}\n\t.st7{fill:#A27267;}\n\t.st8{fill:#12426D;}\n\t.st9{fill:#21AFD6;}\n\t.st10{fill:#228899;}\n\t.st11{fill:#31C0E2;}\n\t.st12{fill:#D5604F;}\n\t.st13{fill:#F4C3BD;}\n\t.st14{fill:#AD82AF;}\n\t.st15{fill:#CB9DC8;}\n\t.st16{fill:#E2BBA1;}\n\t.st17{fill:#EFCEBC;}\n\t.st18{fill:#D3AC98;}\n\t.st19{fill:#F9DFD2;}\n\t.st20{fill:#C4C4C4;}\n\t.st21{fill:#B5B6B6;}\n\t.st22{fill:#B6DEF6;}\n\t.st23{fill:#A1D3EE;}\n\t.st24{fill:#59B4D8;}\n\t.st25{fill:#8D9293;}\n\t.st26{fill:#DE647C;}\n\t.st27{fill:#F4DA6E;}\n\t.st28{fill:#8FC968;}\n\t.st29{fill:#EAEDEF;}\n\t.st30{fill:#439DB2;}\n\t.st31{fill:#51636E;}\n\t.st32{fill:#88584D;}\n\t.st33{fill:#B48176;}\n\t.st34{fill:#3E4F57;}\n\t.st35{fill:#687E87;}\n\t.st36{fill:#11426E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_144_",
    className: "st0",
    points: "552.3,563.8 524.5,582.5 524.5,612.3 552.3,612.3  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_171_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_155_",
    className: "st1",
    points: "526.3,537.6 330,537.6 330,612.3 549.2,612.3 549.2,563.8  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_169_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_146_",
    x: 330,
    y: 591.7,
    className: "st2",
    width: 191.4,
    height: 20.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_145_",
    className: "st2",
    points: "372.6,550.7 385.8,563.8 388.6,557.1 380.6,548.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_143_",
    className: "st2",
    points: "521.4,582.5 527.6,588.1 527.6,614.7 521.4,612.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_142_",
    className: "st0",
    points: "549.2,563.8 521.5,548.1 330,548.1 330,537.6 527.6,537.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_141_",
    className: "st2",
    points: "397.7,591.4 410,569 422,569 410,592.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_140_",
    className: "st2",
    points: "380.3,591.4 392.7,569 404.6,569 392.7,592.7  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_484_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_497_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_139_",
    className: "st3",
    d: "M549.8,612.7c-1.3,0-2.4-1.1-2.4-2.4v-45.7L525.2,540H348.1c-1.3,0-2.4-1.1-2.4-2.4 c0-1.3,1.1-2.4,2.4-2.4h179.3l24.8,27.7v47.5C552.2,611.7,551.1,612.7,549.8,612.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_495_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_138_",
    className: "st3",
    d: "M521.4,613.9c-0.8,0-1.5-0.7-1.5-1.5v-31.6l29.1-18.3c0.7-0.4,1.6-0.2,2.1,0.5 c0.4,0.7,0.2,1.6-0.5,2.1l-27.7,17.4v29.9C522.9,613.2,522.2,613.9,521.4,613.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_491_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_492_",
    className: "st3",
    d: "M379.6,568.7c-6.3,0-11.4-5.1-11.4-11.4c0-6.3,5.1-11.4,11.4-11.4s11.4,5.1,11.4,11.4 C391,563.5,385.9,568.7,379.6,568.7z M379.6,550.6c-3.7,0-6.6,3-6.6,6.6s3,6.6,6.6,6.6s6.6-3,6.6-6.6S383.2,550.6,379.6,550.6z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_489_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_135_",
    className: "st3",
    d: "M521.4,593.2H375.3c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5h146.1 c0.8,0,1.5,0.7,1.5,1.5C522.9,592.5,522.2,593.2,521.4,593.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_487_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_134_",
    className: "st3",
    d: "M535.6,588.2c-0.5,0-0.9-0.2-1.2-0.6c-0.5-0.7-0.3-1.6,0.3-2.1l14.2-10.3 c0.7-0.5,1.6-0.3,2.1,0.3c0.5,0.7,0.3,1.6-0.3,2.1l-14.2,10.3C536.2,588.1,535.9,588.2,535.6,588.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_485_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_133_",
    className: "st3",
    d: "M535.6,604.5c-0.5,0-0.9-0.2-1.2-0.6c-0.5-0.7-0.3-1.6,0.3-2.1l14.2-10.3 c0.7-0.5,1.6-0.3,2.1,0.3c0.5,0.7,0.3,1.6-0.3,2.1l-14.2,10.3C536.2,604.4,535.9,604.5,535.6,604.5z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Background_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_156_",
    className: "st1",
    d: "M142.4,393.8h-39.1l-1.4,7.3c0,0-29.7,4.9-31.5-26.1c0,0,8.5,3,13-10.2c0,0,19.7-3.7,9-27.1 c0,0-28.8,0.8-30.6-53.5l-6.6,10l-3.5,2.9c0,0-19.2,7-11.3,25.9c0,0-30.4,25.4,8.7,52.9c0,0-2.7,51.5,52.8,46.2v7.7 c0,0-31.5-0.5-31.5,31.5v151.1h71.9V393.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_154_",
    className: "st2",
    d: "M57.1,376.2c0,0-5,36.2,44.8,38.2v7.7l-20.4,0L68,415.9c0,0-20.7-14.5-18.9-40L57.1,376.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_153_",
    className: "st0",
    points: "103.3,393.8 117.6,408.4 142.4,393.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_152_",
    className: "st0",
    d: "M61.8,374.1c0,0,12.7-7.4,8.7-20.8c0,0,22.5,3.9,22-15.5c0,0,12.7,17.8-9,27.1 C83.4,364.9,83.6,379.3,61.8,374.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_151_",
    className: "st2",
    d: "M51.7,300c0,0-14.5,18.5-2.7,28.2c0,0-25.8,15.5,0.1,47.7c0,0-37.6-16.7-8.7-52.9 C40.4,323.1,32,303.1,51.7,300z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_150_",
    className: "st2",
    d: "M55.6,325c0,0-17.1,19.8,5.3,29.8c0,0-9.2-14.6,2-20.9L55.6,325z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_149_",
    className: "st2",
    cx: 92.4,
    cy: 453.8,
    r: 3.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_148_",
    className: "st2",
    points: "117.6,408.4 142.4,393.8 142.4,612.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_147_",
    className: "st0",
    d: "M101.9,429.8c0,0-27.1,19.3-21.8,58.6s16,123.9,16,123.9H70.4V454.6 C70.4,454.6,72.9,430.8,101.9,429.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_461_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_480_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_481_",
    className: "st3",
    d: "M92.4,465.2c-6.3,0-11.4-5.1-11.4-11.4c0-6.3,5.1-11.4,11.4-11.4c6.3,0,11.4,5.1,11.4,11.4 C103.8,460.1,98.7,465.2,92.4,465.2z M92.4,447.2c-3.6,0-6.6,3-6.6,6.6c0,3.6,3,6.6,6.6,6.6c3.6,0,6.6-3,6.6-6.6 C99,450.2,96,447.2,92.4,447.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_478_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_130_",
    className: "st3",
    d: "M70.4,614.4c-1.3,0-2.4-1.1-2.4-2.4V461.3c0-17.9,13.9-32.6,31.5-33.8v-36.1H133 c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4h-28.7v36h-2.4c-16,0-29.1,13-29.1,29.1V612C72.8,613.3,71.7,614.4,70.4,614.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_476_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_129_",
    className: "st3",
    d: "M79.1,565.3c-0.8,0-1.5-0.7-1.5-1.5v-57.4c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v57.4 C80.6,564.6,79.9,565.3,79.1,565.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_474_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_128_",
    className: "st3",
    d: "M79.1,501.3c-0.8,0-1.5-0.7-1.5-1.5v-11.3c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v11.3 C80.6,500.6,79.9,501.3,79.1,501.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_472_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_127_",
    className: "st3",
    d: "M133,533.3c-0.8,0-1.4-0.6-1.5-1.3l-15.6-124.8l-15-12.2c-0.7-0.5-0.8-1.5-0.2-2.1 c0.5-0.7,1.5-0.8,2.1-0.2l16,13l0.1,0.6l15.7,125.4c0.1,0.8-0.5,1.6-1.3,1.7C133.2,533.3,133.1,533.3,133,533.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_470_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_126_",
    className: "st3",
    d: "M96.2,404c-5.4,0-13.3-1-19.5-6.2c-5.8-4.8-8.7-12.2-8.7-21.9c0-1.3,1.1-2.4,2.4-2.4 c1.3,0,2.4,1.1,2.4,2.4c0,8.2,2.4,14.3,7,18.2c8.4,7,21.5,4.7,21.6,4.7c1.3-0.2,2.6,0.6,2.8,1.9c0.2,1.3-0.6,2.6-1.9,2.8 C102.1,403.6,99.7,404,96.2,404z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_468_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_125_",
    className: "st3",
    d: "M94.4,425c-8.5,0-22.2-1.6-32.9-10.8c-9.9-8.4-14.9-21.3-14.9-38.3v-2.4h23.7 c0,0,6.2-0.1,9.1-3.3c1.2-1.3,1.7-3,1.5-5.1l-0.2-1.7l1.6-0.7c0.1,0,8.6-3.7,10.7-10.8c1.2-3.8,0.2-8.1-2.8-12.7 c-0.7-1.1-0.4-2.6,0.7-3.3c1.1-0.7,2.6-0.4,3.3,0.7c3.9,5.9,5,11.5,3.4,16.8c-2.2,7.2-8.9,11.5-11.9,13.1c-0.1,2.8-1,5.1-2.8,7.1 c-4.4,4.8-12.3,4.9-12.7,4.9H51.5c0.4,14.3,4.8,25.2,13.1,32.3c14.6,12.5,36.7,9.2,36.9,9.2c1.3-0.2,2.5,0.7,2.7,2 c0.2,1.3-0.7,2.5-2,2.7C101.9,424.6,98.9,425,94.4,425z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_466_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_124_",
    className: "st3",
    d: "M88.1,424.1c-0.8,0-1.5-0.7-1.5-1.5v-21.9c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v21.9 C89.7,423.4,89,424.1,88.1,424.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_464_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_123_",
    className: "st3",
    d: "M49.1,378.3c-0.4,0-0.7-0.1-1.1-0.2c-0.7-0.3-16.8-8.5-20.2-24.3c-2.1-9.8,1.2-20.2,9.8-31 c-1.2-2.7-3.2-8.4-0.9-14.5c2.2-6,7.8-10.5,16.5-13.4c1.3-0.4,2.6,0.3,3,1.5c0.4,1.3-0.3,2.6-1.5,3c-7.3,2.4-11.9,6-13.5,10.5 c-2.2,6,1.3,11.8,1.3,11.9l0.9,1.5l-1.1,1.3c-8.3,10-11.6,19.5-9.8,28.1c2.9,13.6,17.5,21,17.6,21.1c1.2,0.6,1.7,2,1.1,3.2 C50.8,377.8,50,378.3,49.1,378.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_462_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_122_",
    className: "st3",
    d: "M61.8,357.7c-0.4,0-0.8-0.1-1.1-0.3c-0.2-0.1-5.5-3-6.7-9.1c-0.8-4.5,0.7-9.3,4.7-14.4 c-4.8-5.9-18.9-27.1,1.3-51.2c0.9-1,2.4-1.2,3.4-0.3c1,0.9,1.1,2.4,0.3,3.4c-21,25-1,45.5-0.1,46.4l1.6,1.6l-1.5,1.7 c-3.9,4.5-5.5,8.5-4.9,12c0.7,3.8,4.2,5.8,4.2,5.8c1.2,0.6,1.6,2.1,1,3.3C63.4,357.3,62.6,357.7,61.8,357.7z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Right_Arm"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_157_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_117_",
    className: "st4",
    d: "M492.7,472.2c0,0-17.4-9.9-3.8-28.9l19.7,5.6l17.6,10.4L540,474l3.4,6.4 c0,0-0.8,28-38.3,35.6l-2-7.1l-2.8-5.9l6.1-7.3l7.6-11.9l-11.8-4.2L492.7,472.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_116_",
    className: "st5",
    d: "M484.1,453.8c0,0,21.9,23.3,40.4,26.6C524.5,480.4,488.7,484.3,484.1,453.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_115_",
    className: "st5",
    d: "M505.7,510.3c0,0,23.6-11.1,35.7-34.1l2.1,4.2c0,0-5.6,32.2-36,35.3L505.7,510.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_114_",
    className: "st6",
    d: "M484.7,451.5c0,0,31.3,0.6,58.8,28.9c0,0-18.1-31.6-54.5-37.1L484.7,451.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_75_",
    className: "st7",
    d: "M494.7,502.1l-5.1,0.8l-2.9,7.4l2.3,12.1l7.2,7.7c0,0,6.7,0.1,8.9,0c2.1-0.1,9-6.5,9-6.5 l-3-4.2l-6-3.3l-2-7.1L494.7,502.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_188_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st8",
    d: "M521.6,484.5c-19.3,0-32.1-11.8-32.6-12.3c-1-0.9-1-2.4-0.1-3.3c0.9-1,2.4-1,3.3-0.1 c0.1,0.1,12.3,11.4,30.1,11c1.3,0,2.4,1,2.4,2.3c0,1.3-1,2.4-2.3,2.4C522.1,484.5,521.8,484.5,521.6,484.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_186_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st8",
    d: "M503,518.8l-0.2-2.4c-0.8-7.7-4.8-9.7-4.8-9.7l-3.3-1.5l2.7-2.5 c12.7-11.6,12.8-21.4,12.8-21.5c0-1.3,1-2.4,2.3-2.4c0,0,0,0,0,0c1.3,0,2.3,1,2.4,2.3c0,0.5,0.1,10.7-12.3,23.1 c1.7,1.6,3.6,4.5,4.6,9.1c29.4-5.2,33.5-28.7,33.9-32.6c-9.2-20.5-36.8-34.2-58.3-36.7c-1.3-0.2-2.2-1.3-2.1-2.6 c0.2-1.3,1.3-2.2,2.6-2.1c23.6,2.7,52.6,17.4,62.3,40.1l0.2,0.5l0,0.6c0,0.3-2.5,32.6-40.4,37.8L503,518.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_182_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st8",
    d: "M501.4,533.4c-4.2,0-11.9-1.6-16.1-11.9c-0.5-1.2,0.1-2.6,1.3-3.1c1.2-0.5,2.6,0.1,3.1,1.3 c3,7.4,8,9,11.7,9c0,0,0,0,0,0c4.8,0,8.9-2.6,9.6-4.4c0.2-0.5,0.2-0.9,0-1.4c-0.9-1.9-4.6-3.8-6.7-4.5c-1.2-0.4-1.9-1.8-1.5-3 c0.4-1.2,1.8-1.9,3-1.5c0.8,0.3,7.4,2.6,9.4,7c0.8,1.7,0.8,3.5,0.1,5.2C513.8,530.1,507.6,533.4,501.4,533.4 C501.4,533.4,501.4,533.4,501.4,533.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_184_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st8",
    d: "M487.1,508.8c-0.3,0-0.5,0-0.8-0.1c-1.2-0.4-1.9-1.8-1.4-3c1.3-3.6,3.6-5,5.3-5.5 c4.6-1.4,9.6,2.1,10.1,2.5c1.1,0.8,1.3,2.3,0.5,3.3c-0.8,1.1-2.2,1.3-3.3,0.5c-0.9-0.7-4-2.4-6-1.8c-0.4,0.1-1.4,0.4-2.2,2.6 C489,508.2,488.1,508.8,487.1,508.8z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Left_Leg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_121_",
    className: "st9",
    d: "M441.1,512.7c0,0-17.6,39.6-3.6,80.2l6.2,2.3l11.6,14.2c0,0-1.7-55.2,10.2-69.1 C465.5,540.3,462.1,515.1,441.1,512.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_82_",
    className: "st10",
    points: "434.3,580.1 436.9,591 443.7,595.2 453.7,605 454.5,584.1 448.6,580.1 441.1,578.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_80_",
    className: "st11",
    d: "M441.1,578.3c0,0-1.5-34.3,5.8-51.9l-2.9-6.4l-4.5-6.1l-3.9,12.9l-3.1,23.4l1.9,17.6l0.9,10.4 H441.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_79_",
    className: "st12",
    points: "417.2,609.4 423.2,597.4 432.4,592.7 443.7,595.2 453.7,605 455.5,612.3 421.8,612  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_77_",
    className: "st13",
    points: "418.5,605 416.7,612.3 455.5,612.3 453.7,605  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_208_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st8",
    d: "M416.7,614.7c-0.1,0-0.2,0-0.2,0c-1.3-0.1-2.2-1.3-2.1-2.6c0.1-0.5,1.4-13,10-18.7 c4.6-3.1,10.2-3.6,16.7-1.7c5.2,1.5,8.8,4,11.2,6.6c-0.7-18.8,0-50.7,11.8-59.9c1-0.8,2.5-0.6,3.3,0.4c0.8,1,0.6,2.5-0.4,3.3 c-11.5,9-10.8,49.1-9.3,67.1c0.3,1.9,0.3,3.1,0.3,3.1l-4.7,0.1c0-0.3-0.1-1.4-0.3-3.1c-0.7-3.7-3.4-10.3-13.2-13.2 c-5.1-1.5-9.4-1.2-12.8,1.1c-6.7,4.5-7.9,15.1-7.9,15.2C418.9,613.8,417.9,614.7,416.7,614.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_204_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st8",
    d: "M437.4,595.3c-1,0-1.9-0.6-2.3-1.7c-12.7-40.6,1.9-83.6,2.6-85.4c0.4-1.2,1.8-1.9,3-1.5 c1.2,0.4,1.9,1.8,1.5,3c-0.2,0.4-14.8,43.4-2.5,82.5c0.4,1.2-0.3,2.6-1.5,3C437.9,595.3,437.7,595.3,437.4,595.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_200_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "st8",
    d: "M454.5,588.2c-0.4,0-0.9-0.2-1.2-0.6c-9.3-12-17.8-6.7-18.2-6.4c-0.7,0.4-1.6,0.2-2.1-0.4 c-0.4-0.7-0.3-1.6,0.4-2.1c0.1-0.1,11.2-7.1,22.2,7.1c0.5,0.7,0.4,1.6-0.3,2.1C455.1,588.1,454.8,588.2,454.5,588.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_196_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st8",
    d: "M455.5,606.6h-36.2c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h36.2c0.8,0,1.5,0.7,1.5,1.5 S456.4,606.6,455.5,606.6z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Right_Leg"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_85_",
    className: "st9",
    points: "441.1,512.7 446.8,526.4 462.3,539.5 465.5,543 477,575.1 486.7,591.7 498.9,594  513.2,605.1 505.1,581.5 494.7,554.2 489,536.7 487.5,520.6 486.7,510.3 468.2,515.7 452,513 440,509  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_84_",
    className: "st10",
    points: "471.5,516.1 475.9,525.1 486.7,528.4 486.7,510.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_83_",
    className: "st10",
    points: "480.8,583.3 486.7,591.7 498.9,594 511.7,602.7 504,583.3 494.7,579.4 484.7,580.7  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_81_",
    className: "st11",
    d: "M475.9,525.1c0,0,3,28.6,17.1,54.3l12.7,3.9L493,545.1l-4.4-16.6l-6.2-0.4L475.9,525.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_78_",
    className: "st12",
    points: "475.5,609.4 481.5,597.4 490.7,592.7 502,595.2 512.1,605 513.8,612.3 480.1,612  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_76_",
    className: "st13",
    points: "478.7,605 476.8,612.3 515.7,612.3 513.9,605  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_212_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st8",
    d: "M486.7,594.1c-0.8,0-1.5-0.4-2-1.1c-17.7-26.9-20.9-45-21.5-50.7 c-21.1-5.9-26.5-36.1-26.7-37.5c-0.2-1.3,0.6-2.5,1.9-2.7c1.3-0.2,2.5,0.6,2.7,1.9c0.1,0.3,5.4,30.1,24.7,34l1.9,0.4l0,1.9 c0,0.2,0.6,19.2,20.8,50c0.7,1.1,0.4,2.6-0.7,3.3C487.6,593.9,487.2,594.1,486.7,594.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_210_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st8",
    d: "M514.1,614.7c0,0-0.1,0-0.1,0c-1.3-0.1-2.3-1.2-2.2-2.5c0-0.5,0.3-11.8-13.5-15.9 c-5.1-1.5-9.4-1.2-12.7,1c-6.7,4.5-7.9,15.2-7.9,15.3c-0.1,1.3-1.3,2.3-2.6,2.1c-1.3-0.1-2.2-1.3-2.1-2.6c0.1-0.5,1.4-13,10-18.7 c4.6-3.1,10.2-3.6,16.7-1.7c17.5,5.2,16.9,20.6,16.9,20.7C516.4,613.7,515.3,614.7,514.1,614.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_206_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st8",
    d: "M512.5,607.4c-1,0-1.9-0.6-2.2-1.6c-0.1-0.2-7.9-22.7-16.5-46.3c-8.7-24.1-9.4-48.1-9.4-49.1 c0-1.3,1-2.4,2.3-2.4c1.3,0,2.4,1,2.4,2.3c0,0.2,0.8,24.3,9.2,47.6c8.6,23.7,16.4,46.2,16.5,46.4c0.4,1.2-0.2,2.6-1.5,3 C513,607.4,512.8,607.4,512.5,607.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_202_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st8",
    d: "M505.1,585.6c-0.3,0-0.6-0.1-0.9-0.3c-13.3-9.7-22-1.3-22.4-0.9c-0.6,0.6-1.5,0.6-2.1,0 c-0.6-0.6-0.6-1.5,0-2.1c0.1-0.1,10.8-10.6,26.2,0.6c0.7,0.5,0.8,1.4,0.3,2.1C506,585.4,505.6,585.6,505.1,585.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_198_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    className: "st8",
    d: "M513.2,606.6h-36.2c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h36.2c0.8,0,1.5,0.7,1.5,1.5 S514.1,606.6,513.2,606.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_194_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st8",
    d: "M486.2,529.9c-5.1,0-9.1-1.5-12.1-4.4c-4.7-4.7-4.7-11.3-4.7-11.6c0-0.8,0.7-1.5,1.5-1.5 c0,0,0,0,0,0c0.8,0,1.5,0.7,1.5,1.5c0,0.1,0,5.7,3.9,9.5c2.4,2.4,6,3.6,10.5,3.5c0.9,0,1.5,0.6,1.5,1.5c0,0.8-0.6,1.5-1.5,1.5 C486.6,529.9,486.4,529.9,486.2,529.9z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Left_Arm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_120_",
    className: "st4",
    d: "M371.6,416.4c0,0,22.1,48.6,60.1,54.6c0,0,26-5.1,8.3-28.3c0,0-34-3.1-53.4-32.4L371.6,416.4z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_119_",
    className: "st5",
    d: "M378.7,415.1c0,0,18.9,46.5,66.5,46.8c0,0-8.3,15.1-26.5,5.3L399.2,457l-13.1-13.7l-10.4-16 l-4.1-10.9L378.7,415.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_118_",
    className: "st6",
    d: "M386.5,410.2c0,0,10.8,42.2,59.6,44.4c0,0,3.7-4.6-6.2-12C440,442.7,401.4,440.6,386.5,410.2z "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_192_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st8",
    d: "M440,445c-0.1,0-0.1,0-0.2,0c-38.3-2.7-54.9-32.8-55.6-34.1c-0.6-1.2-0.2-2.6,1-3.2 c1.1-0.6,2.6-0.2,3.2,1c0.2,0.3,16.1,29.1,51.7,31.6c1.3,0.1,2.3,1.2,2.2,2.5C442.2,444.1,441.2,445,440,445z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_190_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st8",
    d: "M434.3,472.8C434.3,472.8,434.3,472.8,434.3,472.8c-44.6-1.4-64.3-53.8-65.1-56.1 c-0.4-1.2,0.2-2.6,1.4-3c1.2-0.5,2.6,0.2,3,1.4c0.2,0.5,19.5,51.7,60.8,53c1.3,0,2.3,1.1,2.3,2.4 C436.6,471.8,435.6,472.8,434.3,472.8z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_113_",
    className: "st14",
    d: "M445.4,441.1l-6.5,8.2l-2.8,13.5l-0.6,22.2l4.5,24c0,0,28.1,14.1,46.8,1.3l3.8-29.9l0.4-17.7 l-0.4-13.5l-3.8-6.7C486.7,442.6,471.4,429.7,445.4,441.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    className: "st15",
    d: "M444.9,443.3c0,0-3.6,28.5,8.5,32.7l13.8-7.8l11.6-13.7l3.8-11.3l-7.1-0.7l-7.3,6.8l-7.6,4.2 l-4.5-0.8L444.9,443.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_87_",
    className: "st4",
    d: "M452.8,482.1c0,0,22.3,3.2,37.8-32.8l-3.8-6.7l-4.1,0.7c0,0-10.5,30.1-29.2,32.7L452.8,482.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_86_",
    className: "st4",
    d: "M452.8,482.1c0,0-15.1-7.3-17.6-30.6l10.3-10.5c0,0-6.1,21.7,8,35L452.8,482.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_218_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st8",
    d: "M463.1,516.8c-19.8,0-26-10.6-26.3-11.2l-0.2-0.6c-7-32-6.2-52.9,2.2-62.2 c4.6-5.1,9.8-4.5,10.1-4.5c1.3,0.2,2.2,1.3,2.1,2.6c-0.1,1.3-1.3,2.2-2.6,2.1c-0.2,0-3.2-0.2-6.2,3.1c-4,4.6-9.5,18.2-1,57.4 c1.3,1.9,11.6,14.5,43.4,5l3.2-34.1c1-6.2,2.4-23.3-3.5-29.1c-1.8-1.8-4.2-2.4-7.4-1.8c-1.3,0.2-2.5-0.6-2.7-1.9 c-0.2-1.3,0.6-2.5,1.9-2.7c4.7-0.8,8.6,0.2,11.6,3.1c8.9,8.8,5.1,32.1,4.9,33.1l-3.4,37.1l-1.5,0.5 C477.7,515.6,469.7,516.8,463.1,516.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_216_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st8",
    d: "M457.1,515.4c-0.7,0-1.3-0.5-1.5-1.2c-11.2-54,2.7-61.5,3.3-61.8c0.7-0.4,1.6-0.1,2,0.7 c0.4,0.7,0.1,1.6-0.7,2c-0.3,0.2-12.3,7.8-1.7,58.5c0.2,0.8-0.4,1.6-1.2,1.8C457.3,515.4,457.2,515.4,457.1,515.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_214_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st8",
    d: "M452.3,477.9l-0.6-0.6c-0.5-0.5-13.4-13.3-7.7-36.6c0.2-0.8,1-1.3,1.8-1.1 c0.8,0.2,1.3,1,1.1,1.8c-4.6,19.1,3.9,30.4,6.3,33.2c21.6-6.5,28.4-32.9,28.4-33.2c0.2-0.8,1-1.3,1.8-1.1c0.8,0.2,1.3,1,1.1,1.8 c-0.3,1.2-7.4,29.1-31.4,35.6L452.3,477.9z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Neck"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_89_",
    className: "st7",
    d: "M448.6,428.7v16.3c0,0,7.6,14.6,26.6,0l1.1-9.5L448.6,428.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_220_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st8",
    d: "M460.1,456c-0.8,0-1.6-0.1-2.4-0.2c-7.7-1.4-11.2-9.4-11.4-9.8l-0.2-0.4v-16.8 c0-1.3,1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4v15.8c0.7,1.3,3.3,5.8,7.7,6.6c4,0.7,9-1.7,14.3-7.1l1-8.7c0.2-1.3,1.3-2.2,2.6-2.1 c1.3,0.2,2.2,1.3,2.1,2.6l-1.2,10.3l-0.6,0.6C471,452.9,465.4,456,460.1,456z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Sheet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_95_",
    className: "st16",
    d: "M174.3,307.1v-71.4v-32.3l4.7-15.5l7.2-10.2l11.6-7l18.6-1.8l12.3,3.1l18.2,10.7l13.9,17.7 c0,0-4,112.4,0,108.4S174.3,307.1,174.3,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_94_",
    className: "st17",
    d: "M209.3,167.3l19.3,4.8l15.4,8.4l11.8,10.1l9.4,17.1l6.5,20.3l5.1,26.7l6.3,49.1l3.3,21.8 l5.2,27l9,37.8l11.6,26.2l9.5,10.3l7.7,6.6l5.7-2.1l6.1-16.2l61.8-27.5l-7.3-10.9l-9.5-26.8l-14.7-59.1l-12.4-68l-5.3-35.3 l-11.8-20.2c0,0-17.5-29-58.6-24.9L209.3,167.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_93_",
    className: "st18",
    points: "337.1,429.3 341.1,415.1 417.2,383.6 412.4,400.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_92_",
    className: "st18",
    d: "M174.3,235.7c0,0,34.8-40.3,84.3-27.7l2-7.5c0,0-49.7-59.2-81.7-12.6l-4.7,15.5V235.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_91_",
    className: "st19",
    d: "M276.8,254.6c0,0,54.1-28.7,90.6,13.8l-8.3-45.7l-7.9-36.8l-9.2-18.7c0,0-16.2-31.7-58.6-24.9 L204,168.9c0,0,41.4-4.7,61.2,38.7l6.5,20.3L276.8,254.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_90_",
    className: "st16",
    d: "M295.1,367.3c0,0,28.4,45.5,83.6,31l-37.7,16.8l-0.6,11.6l-5.5,4.6 C335,431.3,307.3,428.2,295.1,367.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_293_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st8",
    d: "M260.6,311.2c-1.3,0-2.4-1.1-2.4-2.4V200.5c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4 v108.4C263,310.1,261.9,311.2,260.6,311.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_291_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "st8",
    d: "M406.8,389.9c-0.2,0-0.4,0-0.6-0.1c-4.3-1-17.3-4.2-36.6-95.8c-9.4-44.6-15.8-89.1-15.9-89.6 c-5.2-25.4-15.5-43.1-30.5-52.5c-17.6-10.9-35.6-6.3-35.8-6.3l-86.3,26.5c-1.2,0.4-2.6-0.3-3-1.6c-0.4-1.2,0.3-2.6,1.6-3 l86.4-26.5c0.9-0.2,20.3-5.2,39.6,6.8c16.2,10.1,27.2,28.8,32.7,55.7c10.1,70.8,31.4,177.4,48.9,181.6c1.3,0.3,2.1,1.6,1.7,2.9 C408.8,389.2,407.9,389.9,406.8,389.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_287_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_288_",
    className: "st8",
    d: "M331.7,434.6c-10.3,0-23.8-17.5-33.4-43.5c-11.8-32.2-22.2-120.6-25.1-146.9 c-1.4-12.8-4.8-24.7-10.1-35.5c-7.2-14.6-20.7-32.8-44-36.6c-12.6-2.1-22.7,0-30,6.1c-12.3,10.4-12.5,29.4-12.5,29.6v100.4 c0,1.3-1.1,2.4-2.4,2.4s-2.4-1.1-2.4-2.4V207.8c0-0.9,0.2-21.3,14.1-33.2c8.3-7.1,19.7-9.5,33.8-7.2c25.2,4.2,39.7,23.6,47.4,39.2 c5.6,11.3,9.1,23.7,10.6,37.1c2.9,26.2,13.2,114.1,24.9,145.8c9.6,26.1,22.7,41.2,29.5,40.4c0,0,0,0,0,0l1.6-0.7 c2.5-1.8,4.2-6.8,4.8-14.2l0.1-1.4l82.2-34.4l0.2,3.4c0.7,14.6-15.9,22.8-16.6,23.1l-68.2,27.7c-1,0.6-2.2,1.1-3.4,1.2 C332.5,434.5,332.1,434.6,331.7,434.6z M343.3,416.7c-0.4,3.7-1,6.8-1.9,9.4l61.3-24.9c0,0,11.4-5.7,13.5-15L343.3,416.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_180_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st8",
    d: "M246.8,171.3c-1,0-1.9-0.6-2.2-1.6c-0.4-1.2,0.2-2.6,1.5-3l49.8-17c1.2-0.4,2.6,0.2,3,1.5 c0.4,1.2-0.2,2.6-1.5,3l-49.8,17C247.3,171.2,247,171.3,246.8,171.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_178_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st8",
    d: "M260.6,182.8c-1,0-1.9-0.6-2.2-1.6c-0.4-1.2,0.2-2.6,1.5-3l57.7-19.5c1.2-0.4,2.6,0.2,3,1.5 c0.4,1.2-0.2,2.6-1.5,3l-57.7,19.5C261.1,182.8,260.9,182.8,260.6,182.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_176_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st8",
    d: "M274,199.6c-1,0-1.9-0.6-2.2-1.6c-0.4-1.2,0.2-2.6,1.5-3l57.7-19.5c1.2-0.4,2.6,0.2,3,1.5 c0.4,1.2-0.2,2.6-1.5,3l-57.7,19.5C274.5,199.5,274.3,199.6,274,199.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_174_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st8",
    d: "M283.3,220.3c-1,0-1.9-0.6-2.2-1.6c-0.4-1.2,0.2-2.6,1.5-3l57.7-19.5c1.2-0.4,2.6,0.2,3,1.5 c0.4,1.2-0.2,2.6-1.5,3l-57.7,19.5C283.8,220.2,283.6,220.3,283.3,220.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_172_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st8",
    d: "M289.5,244.6c-1,0-1.9-0.6-2.2-1.6c-0.4-1.2,0.2-2.6,1.5-3l57.7-19.5c1.2-0.4,2.6,0.2,3,1.5 c0.4,1.2-0.2,2.6-1.5,3l-57.7,19.5C290,244.5,289.7,244.6,289.5,244.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_170_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st8",
    d: "M293.4,269.4c-1,0-1.9-0.6-2.2-1.6c-0.4-1.2,0.2-2.6,1.5-3l57.7-19.5c1.2-0.4,2.6,0.2,3,1.5 c0.4,1.2-0.2,2.6-1.5,3l-57.7,19.5C293.9,269.3,293.6,269.4,293.4,269.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_168_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st8",
    d: "M296,292.9c-1,0-1.9-0.6-2.2-1.6c-0.4-1.2,0.2-2.6,1.5-3l57.7-19.5c1.2-0.4,2.6,0.2,3,1.5 c0.4,1.2-0.2,2.6-1.5,3l-57.7,19.5C296.5,292.9,296.2,292.9,296,292.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_166_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st8",
    d: "M302,317.2c-1,0-1.9-0.6-2.2-1.6c-0.4-1.2,0.2-2.6,1.5-3l57.7-19.5c1.2-0.4,2.6,0.2,3,1.5 c0.4,1.2-0.2,2.6-1.5,3l-57.7,19.5C302.5,317.2,302.2,317.2,302,317.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_164_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st8",
    d: "M329.3,407.8c-0.9,0-1.8-0.6-2.2-1.5c-0.5-1.2,0.1-2.6,1.3-3.1l56.8-22.1 c1.2-0.5,2.6,0.1,3.1,1.3c0.5,1.2-0.1,2.6-1.3,3.1l-56.8,22.1C329.9,407.7,329.6,407.8,329.3,407.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_162_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st8",
    d: "M318.8,387.9c-1,0-1.9-0.6-2.2-1.5c-0.5-1.2,0.1-2.6,1.4-3.1l56.9-21.7 c1.2-0.5,2.6,0.1,3.1,1.4c0.5,1.2-0.1,2.6-1.4,3.1l-56.9,21.7C319.3,387.8,319,387.9,318.8,387.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_160_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st8",
    d: "M311.7,365.8c-1,0-1.9-0.6-2.2-1.6c-0.4-1.2,0.2-2.6,1.4-3l57.5-20.2c1.2-0.4,2.6,0.2,3,1.4 c0.4,1.2-0.2,2.6-1.4,3l-57.5,20.2C312.2,365.7,312,365.8,311.7,365.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_158_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st8",
    d: "M308.1,341.2c-1,0-1.9-0.6-2.2-1.6c-0.4-1.2,0.2-2.6,1.4-3l57.5-20.2c1.2-0.4,2.6,0.2,3,1.4 c0.4,1.2-0.2,2.6-1.4,3L308.9,341C308.6,341.1,308.4,341.2,308.1,341.2z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Machine"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_112_",
    className: "st20",
    d: "M133.1,352.8v177.8h-19.7l-21,19.9v31.1l-9,5.1l-3.3,5v20.7h299.4v-15.5l-1-5.1l-4.8-6 l-11.5-3.2c0,0,9.6-49.2-43.9-60v-42.1h-26.7v-64.7V352l-4.5-11.2l-10.2-8.2l-10.6-1.8H161l-13.2,1.8l-6.3,3.9l-5.1,6.1 L133.1,352.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_111_",
    className: "st21",
    d: "M192,330.8c0,0-21.4,254,114.6,250.8H92.4l2.5-33.4l18.5-17.6h19.7V350.1 c0,0,4.1-19.9,27.9-19.3H192z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_110_",
    className: "st22",
    points: "151.7,362.1 151.7,554.9 156,562 166.3,567.9 264.7,567.9 272.7,562 274.9,554.9  274.9,366.8 271.9,356 262.7,350.4 256.7,350.1 166.3,350.1 158.5,352  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    className: "st23",
    d: "M151.7,474.8c0,0,95.4,40.9,123.2-77v154.6l-1.4,7.2l-8.7,8.3h-98.4L156,562l-4.4-7.1V474.8z "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_108_",
    className: "st24",
    points: "124.6,554.2 117.4,550.7 110.1,554.2 108.5,558.2 111.4,566.3 116.5,568.5  120.8,567.9 126.3,563.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_107_",
    className: "st24",
    d: "M334.9,527.3c0,0,18.3,22,16.3,55.2h11C362.2,582.5,363.5,540.4,334.9,527.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_106_",
    className: "st25",
    points: "367.1,582.5 90.4,582.5 83.4,586.7 80.1,591.7 80.1,612.3 379.5,612.3 378.5,591.7  376.2,588.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_105_",
    x: 161,
    y: 308.3,
    className: "st24",
    width: 105.2,
    height: 22.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_104_",
    className: "st26",
    cx: 189.1,
    cy: 445.5,
    r: 22.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_103_",
    className: "st27",
    d: "M189.1,422.7l0.6,26.5l22.2-13.2C211.9,436,205.4,421.2,189.1,422.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_102_",
    className: "st27",
    points: "189.7,372 181.5,376.2 179,383.8 184.3,392.4 192,392.4 198.1,389.8 200.4,383.1  198.9,377.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_101_",
    className: "st28",
    d: "M189.7,372v10.2l-7.9,6.1C181.8,388.3,175.1,375.7,189.7,372z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_100_",
    className: "st0",
    points: "224.1,373.1 224.1,435.6 229.8,442.6 241.3,442.7 252.3,440.6 258.4,435.6  258.4,419.8 258.4,372 253.5,366.8 248.2,365.4 232,365.4  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_99_",
    className: "st29",
    d: "M224.1,386.1c0,0,3.6,28.7,34.4,22.7v26.7l-6.1,5l-11.1,2.1l-11.5-0.1l-5.7-9.7L224.1,386.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_98_",
    className: "st30",
    points: "207.3,306.6 200.7,330.8 161,330.8 161,308.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_97_",
    className: "st30",
    points: "113.4,551.5 120.8,567.9 116.5,568.5 111.4,566.3 108.5,560.9 110.1,554.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_96_",
    className: "st30",
    d: "M348.5,555.5c0,0,9.2-0.7,11.7,8.3l2,18.7h-11L348.5,555.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_399_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_68_",
    className: "st8",
    d: "M379.5,614.8c-1.3,0-2.4-1.1-2.4-2.4v-15.5c0-6.1-5-11.1-11.1-11.1H92.6 c-6.1,0-11.1,5-11.1,11.1v15.5c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4v-15.5c0-8.8,7.2-16,16-16h273.4c8.8,0,16,7.2,16,16 v15.5C381.9,613.7,380.8,614.8,379.5,614.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_397_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_67_",
    className: "st8",
    d: "M92.4,585.7c-1.3,0-2.4-1.1-2.4-2.4v-33.8l22.4-20.1h18.2V354.8c0-14.5,11.8-26.3,26.3-26.3 h110.6c14.5,0,26.3,11.8,26.3,26.3v211.4c0,1.3-1.1,2.4-2.4,2.4s-2.4-1.1-2.4-2.4V354.8c0-11.9-9.7-21.6-21.6-21.6H157 c-11.9,0-21.6,9.7-21.6,21.6v179.4h-21.1l-19.5,17.4v31.7C94.7,584.6,93.7,585.7,92.4,585.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_395_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    className: "st8",
    d: "M362.2,585.7c-1.3,0-2.4-1.1-2.4-2.4c0-22.5-5.4-39-16.1-48.8c-11.5-10.6-25.1-9.6-25.2-9.6 l-2.6,0.2v-42.3h-24.3c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4h29.1v42.1c5,0.2,16.3,1.6,26.3,10.9c11.7,10.8,17.6,28.4,17.6,52.3 C364.5,584.6,363.5,585.7,362.2,585.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_391_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_392_",
    className: "st8",
    d: "M257.5,570.4h-88.4c-11,0-20-9-20-20V365.8c0-11,9-20,20-20h88.4c11,0,20,9,20,20v184.7 C277.5,561.5,268.5,570.4,257.5,570.4z M169.1,350.9c-8.2,0-14.8,6.7-14.8,14.8v184.7c0,8.2,6.7,14.8,14.8,14.8h88.4 c8.2,0,14.8-6.7,14.8-14.8V365.8c0-8.2-6.7-14.8-14.8-14.8H169.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_389_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_63_",
    className: "st8",
    d: "M379.5,602.5H79.1c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5h300.4c0.8,0,1.5,0.7,1.5,1.5 C381,601.8,380.3,602.5,379.5,602.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_387_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_62_",
    className: "st8",
    d: "M266.2,333.1c-1.3,0-2.4-1.1-2.4-2.4v-20.1H163.4v20.1c0,1.3-1.1,2.4-2.4,2.4 c-1.3,0-2.4-1.1-2.4-2.4v-24.8h110v24.8C268.6,332.1,267.5,333.1,266.2,333.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_385_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_61_",
    className: "st8",
    d: "M241.3,332.3c-0.5,0-1-0.3-1.3-0.8L227.3,309c-0.4-0.7-0.2-1.6,0.6-2c0.7-0.4,1.6-0.2,2,0.6 l12.7,22.5c0.4,0.7,0.2,1.6-0.6,2C241.8,332.2,241.5,332.3,241.3,332.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_383_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_60_",
    className: "st8",
    d: "M258.6,332.3c-0.5,0-1-0.3-1.3-0.8L244.7,309c-0.4-0.7-0.2-1.6,0.6-2c0.7-0.4,1.6-0.2,2,0.6 l12.7,22.5c0.4,0.7,0.2,1.6-0.6,2C259.1,332.2,258.9,332.3,258.6,332.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_381_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_59_",
    className: "st8",
    d: "M169.6,332.3c-0.8,0-1.5-0.7-1.5-1.5v-22.5c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5v22.5 C171.1,331.6,170.5,332.3,169.6,332.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_377_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_378_",
    className: "st8",
    d: "M117.4,570.9c-6.3,0-11.4-5.1-11.4-11.4s5.1-11.4,11.4-11.4c6.3,0,11.4,5.1,11.4,11.4 S123.6,570.9,117.4,570.9z M117.4,552.9c-3.7,0-6.6,3-6.6,6.6s3,6.6,6.6,6.6c3.7,0,6.6-3,6.6-6.6S121,552.9,117.4,552.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_375_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_56_",
    className: "st8",
    cx: 306.5,
    cy: 494.1,
    r: 5.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_373_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    className: "st8",
    d: "M142.3,525.6c-0.8,0-1.5-0.7-1.5-1.5v-94.3c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v94.3 C143.8,524.9,143.2,525.6,142.3,525.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_371_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    className: "st8",
    d: "M142.3,423.6c-0.8,0-1.5-0.7-1.5-1.5v-21c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v21 C143.8,423,143.2,423.6,142.3,423.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_362_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    className: "st8",
    d: "M252.3,338.7h-42c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h42c0.8,0,1.5,0.7,1.5,1.5 S253.1,338.7,252.3,338.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_359_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_52_",
    className: "st8",
    d: "M350.8,584.8c0,0-0.1,0-0.1,0c-0.8-0.1-1.4-0.8-1.3-1.6c3.2-34-17.2-56.8-17.4-57 c-0.6-0.6-0.5-1.6,0.1-2.1c0.6-0.6,1.6-0.5,2.1,0.1c0.2,0.2,21.5,24,18.1,59.3C352.2,584.2,351.6,584.8,350.8,584.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_357_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_51_",
    className: "st8",
    d: "M194.3,550.6C194.3,550.6,194.3,550.6,194.3,550.6c-2.4,0-4.4-1.4-5.2-3.7l-9.7-26.7 c-0.2-0.5-0.6-0.6-0.8-0.6c-0.2,0-0.7,0-0.9,0.5l-9.2,18.5c-0.6,1.2-2,1.6-3.2,1.1c-1.2-0.6-1.6-2-1.1-3.2l9.2-18.5 c1-2.1,3.1-3.3,5.4-3.1c2.3,0.1,4.2,1.6,5,3.7l9.7,26.7c0.2,0.5,0.6,0.6,0.8,0.6l0,0c0.2,0,0.6-0.1,0.8-0.6l16.3-44.8 c0.7-2,2.6-3.4,4.8-3.4c0,0,0,0,0,0c2.2,0,4.1,1.4,4.8,3.4l13,37.1c0,0.1,0.1,0.4,0.5,0.4c0.4,0,0.5-0.3,0.5-0.4l15-57.8 c0.3-1.3,1.6-2,2.9-1.7c1.3,0.3,2,1.6,1.7,2.9l-15,57.8c-0.6,2.3-2.6,3.9-4.9,3.9c-2.3,0.1-4.4-1.3-5.2-3.5l-13-37.1 c0-0.1-0.1-0.2-0.4-0.3c0,0,0,0,0,0c-0.3,0-0.3,0.2-0.4,0.2l-16.3,44.8C198.7,549.1,196.7,550.6,194.3,550.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_355_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    className: "st8",
    d: "M264.7,487.4c-0.9,0-1.8-0.5-2.2-1.4l-7.8-17.6l-13.6,13.7c-0.9,0.9-2.4,0.9-3.3,0 c-0.9-0.9-0.9-2.4,0-3.3l18.5-18.6l10.6,23.9c0.5,1.2,0,2.6-1.2,3.1C265.4,487.3,265.1,487.4,264.7,487.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_353_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_49_",
    className: "st8",
    d: "M274.9,557.2H151.7c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5h123.2 c0.8,0,1.5,0.7,1.5,1.5C276.4,556.5,275.7,557.2,274.9,557.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_348_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_349_",
    className: "st8",
    d: "M189.5,470.7c-14.1,0-25.6-11.5-25.6-25.6s11.5-25.6,25.6-25.6s25.6,11.5,25.6,25.6 S203.7,470.7,189.5,470.7z M189.5,424.2c-11.5,0-20.9,9.4-20.9,20.9s9.4,20.9,20.9,20.9s20.9-9.4,20.9-20.9S201,424.2,189.5,424.2 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_346_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    className: "st8",
    d: "M188.1,451.7v-29.8c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v25.1l20.2-9.6c0.8-0.4,1.6,0,2,0.7 c0.4,0.7,0,1.6-0.7,2L188.1,451.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_316_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_341_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_342_",
    className: "st8",
    d: "M247.2,445.7h-11.9c-7.5,0-13.6-6.1-13.6-13.6v-56c0-7.5,6.1-13.6,13.6-13.6h11.9 c7.5,0,13.6,6.1,13.6,13.6v56C260.8,439.6,254.7,445.7,247.2,445.7z M235.3,367.2c-4.9,0-8.9,4-8.9,8.9v56c0,4.9,4,8.9,8.9,8.9 h11.9c4.9,0,8.9-4,8.9-8.9v-56c0-4.9-4-8.9-8.9-8.9H235.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_335_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_339_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    className: "st8",
    d: "M251.7,380.4h-20.8c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h20.8c0.8,0,1.5,0.7,1.5,1.5 S252.5,380.4,251.7,380.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_337_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    className: "st8",
    d: "M251.7,391.3h-20.8c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h20.8c0.8,0,1.5,0.7,1.5,1.5 S252.5,391.3,251.7,391.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_330_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_333_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    className: "st8",
    d: "M251.7,402.1h-20.8c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5h20.8 c0.8,0,1.5,0.7,1.5,1.5C253.2,401.4,252.5,402.1,251.7,402.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_331_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_69_",
    className: "st8",
    d: "M251.7,413.1h-20.8c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5h20.8 c0.8,0,1.5,0.7,1.5,1.5C253.2,412.4,252.5,413.1,251.7,413.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_317_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_40_",
    className: "st8",
    cx: 241.3,
    cy: 427.4,
    r: 5.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_312_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_313_",
    className: "st8",
    d: "M189.7,396.2c-7.2,0-13.1-5.9-13.1-13.1s5.9-13.1,13.1-13.1s13.1,5.9,13.1,13.1 S196.9,396.2,189.7,396.2z M189.7,374.7c-4.6,0-8.4,3.8-8.4,8.4s3.8,8.4,8.4,8.4s8.4-3.8,8.4-8.4S194.3,374.7,189.7,374.7z"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Head_6_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_369_",
    className: "st7",
    points: "405.9,348.7 404.9,353.3 398.6,353.6 391.6,357 390.5,362.5 390.7,372.9 399.7,376.8  397.1,388.5 400.1,403.5 408,414.6 417.2,420.1 431.6,423.3 505,439.5 517.1,440.6 531.2,432.5 535.8,426.1 542.2,411 548,409.6  555,403.9 556.6,396 553.3,388.8 548,384.9 531.1,377.2 506.8,359.5 479.5,335.6 466,322.7 460.7,328.6 454.4,332.3 444.9,332.8  434.1,327 427.4,337.9 422.4,343.5 412.1,349.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_368_",
    className: "st31",
    d: "M405.3,349.1l9.5-1.2l14-12.1l5.4-8.7l12.1,7l6.4,0.4l8.1-5.7l5.2-5.9l26.5,24.3l40.8,31.8 l7.6,2.9l10.3,3.6l9.7-3.2l7.9-11.4l4.2-20.8l-2.8-19c0,0-2-5.8-3.4-6.4c-1.4-0.5-8.7-8-8.7-8l-6.6-0.9l-5.2,1.6L541,322l-3.7,1.9 l-6-1.7l-4.9-3.2c0,0-3.5-6.7-4.1-7.3c-0.6-0.6-9.5-4.6-9.5-4.6l-9.1,3.9l-14.9-11.2l-20-7.9l-14-3.9l-19.1-0.8l-17.3,4.4 l-11.6,12.1l-6,12.1l-2.5,12.4l2.8,13.9L405.3,349.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_367_",
    className: "st32",
    d: "M396.9,389.4c0,0,5.5,18.9,25.9,23.4c20.5,4.5,43.8,9.7,43.8,9.7l-1.8,8.2L416.6,420 l-9.2-4.7l-6.6-7.3l-3.3-7.5L396.9,389.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_366_",
    className: "st32",
    d: "M539,420.7c0,0-12.9,14.8-33.4,10.3c-20.5-4.5-43.8-9.7-43.8-9.7l-1.8,8.2l48.2,10.6 l10.3-0.4l9.1-3.8l6.1-5.4L539,420.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_365_",
    className: "st33",
    d: "M469.2,399.5l6.8-30.8c0,0,6,12.6,4,24.5l-4.2,6l-5.3,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_364_",
    className: "st32",
    d: "M403.4,357.7c0,0,25.6,0.8,30.1-29.6l-6.1,9.8l-8.6,8.5l-6.7,2.9l-6.2-0.7L403.4,357.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_363_",
    className: "st32",
    d: "M432.1,334.7c0,0,19.5,12.3,33.9-9.5l-1.9-0.4l-8.2,8.2l-9.7,0.9l-12.8-5.9l-2.9,4.7 L432.1,334.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_360_",
    className: "st32",
    d: "M459.3,329.6c0,0,38.3,45.7,86.6,55.3L521.2,372l-23.6-20.6L476,333.3L466,322.7L459.3,329.6 z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_350_",
    transform: "matrix(0.9765 0.2156 -0.2156 0.9765 97.4865 -100.2498)",
    className: "st33",
    cx: 508.3,
    cy: 396.8,
    rx: 8.5,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_343_",
    transform: "matrix(0.9765 0.2156 -0.2156 0.9765 92.1972 -84.5992)",
    className: "st33",
    cx: 433.9,
    cy: 380.4,
    rx: 8.5,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_336_",
    className: "st34",
    d: "M400.6,339c0,0,15.5,3.3,32-12l-8.4,14.5l-9.5,6.4l-8.9,0.8L400.6,339z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_328_",
    className: "st34",
    d: "M432.8,325.8c0,0,16.9,8.7,31.3-3.5l-3.4,6.3l-8.1,5.7l-10.7-1.1l-8.5-5.2L432.8,325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_327_",
    className: "st34",
    d: "M497.7,351.5c0,0,48,37.5,70,21.2l-6.7,9.5l-5.8,4l-13.3-3.3l-14.3-6.7l-16.6-12.4 L497.7,351.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_326_",
    className: "st35",
    d: "M398.8,326.2c0,0,6.3-40.4,60.2-29.8c0,0,28.9,14.2,38.5,9.5c0,0-35.2-25.6-66.9-17.7 C430.5,288.2,399.8,293.6,398.8,326.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_325_",
    className: "st35",
    d: "M484.3,330.8c0,0,46.8,38.3,66.4,39.5C550.7,370.3,538.5,384.4,484.3,330.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_309_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_321_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_322_",
    className: "st36",
    d: "M546.7,387c-23.1-5.1-71.6-51.8-81.1-61.1c-2.2,2.9-7.2,8.2-14.4,9.4 c-5.6,0.9-11.3-0.8-17.1-5.1c-3.5,6.6-15.4,26-29.5,20.6l-0.5-0.2l-0.3-0.5c-0.2-0.3-4.7-7-6.3-16.9c-1.5-9.1-0.6-22.8,11.8-35.6 c8.3-8.6,20-12.7,34.6-12.3c23.9,0.7,49.7,13.6,59.4,23.3c1.9-1.4,5.4-3.4,9.9-2.9c5.6,0.6,10.8,4.8,15.5,12.5 c0.3,0.4,3.1,4,6.5,4.2c1.8,0.1,3.7-0.8,5.4-2.8c3.8-4.2,9.1-6.1,14.4-5.2c6.8,1.1,12.8,6.4,16.4,14.5c4.9,11.1,4,38.5-6.4,51.3 c-4.7,5.9-11,8.2-18.1,6.8C546.9,387,546.8,387,546.7,387z M465,320.1l1.7,1.7c0.6,0.6,56.8,56.3,80.8,61.6c0.1,0,0.2,0,0.3,0.1 c5.7,1.2,10.6-0.7,14.5-5.5c9.4-11.7,10.3-37.5,5.9-47.6c-3.1-7-8-11.5-13.6-12.4c-4.2-0.7-8.1,0.8-11.1,4 c-2.6,2.8-5.4,4.1-8.4,3.9c-5.4-0.3-9.2-5.6-9.3-5.8l-0.1-0.1c-4-6.6-8.3-10.3-12.7-10.8c-4.8-0.5-8.4,3-8.4,3.1l-1.4,1.4 l-1.3-1.5c-7.9-9.1-34.4-22.7-58-23.3c-13.6-0.4-24.3,3.4-31.9,11.2l-1.3-1.3l1.3,1.3c-20.1,20.8-7.6,43.8-5.4,47.4 c13.2,4.3,25.2-20.7,25.4-21l1-2.2l1.8,1.5c5.5,4.6,10.8,6.5,15.9,5.7c8.2-1.4,13.1-9.5,13.2-9.5L465,320.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_319_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_320_",
    className: "st36",
    d: "M398.7,379c-7.5-1.6-12.2-9.1-10.5-16.6c1.7-7.5,9.1-12.2,16.5-10.6c1,0.2,1.6,1.2,1.4,2.2 c-0.2,1-1.2,1.6-2.2,1.4c-5.5-1.2-10.9,2.3-12.2,7.8s2.3,11,7.7,12.2c1,0.2,1.6,1.2,1.4,2.2C400.6,378.6,399.6,379.2,398.7,379z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_310_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_318_",
    className: "st36",
    d: "M395.9,365.4c0,0-0.1,0-0.1,0c-0.6-0.2-0.9-0.9-0.7-1.5c1.5-4.7,5.9-5.7,8-5.6 c0.6,0,1.1,0.6,1.1,1.2c0,0.6-0.6,1.1-1.2,1.1c-0.2,0-4.3-0.2-5.6,4C397.1,365.2,396.5,365.5,395.9,365.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_304_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_307_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_308_",
    className: "st36",
    d: "M541.8,410.6c-1-0.2-1.6-1.2-1.4-2.2c0.2-1,1.2-1.6,2.2-1.4c5.5,1.2,10.9-2.3,12.2-7.8 s-2.3-11-7.7-12.2c-1-0.2-1.6-1.2-1.4-2.2c0.2-1,1.2-1.6,2.2-1.4c7.5,1.6,12.2,9.1,10.5,16.6S549.3,412.3,541.8,410.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_305_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_306_",
    className: "st36",
    d: "M550,399.4c-0.6-0.1-1-0.7-0.9-1.3c0.5-4.4-3.3-5.9-3.4-6c-0.6-0.2-0.9-0.9-0.7-1.5 c0.2-0.6,0.9-0.9,1.5-0.7c1.9,0.8,5.5,3.5,4.9,8.4c-0.1,0.6-0.7,1.1-1.3,1C550.1,399.4,550.1,399.4,550,399.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_302_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_303_",
    className: "st36",
    d: "M503.1,441.5l-82.4-18.2c-17.8-3.9-29-21.5-25.1-39.3l7.8-35.4c0.2-1,1.2-1.6,2.2-1.4 c1,0.2,1.6,1.2,1.4,2.2l-7.8,35.4c-3.5,15.8,6.5,31.4,22.3,34.9l82.4,18.2c15.8,3.5,31.4-6.5,34.9-22.3l6.8-30.8 c0.2-1,1.2-1.6,2.2-1.4c1,0.2,1.6,1.2,1.4,2.2l-6.8,30.8C538.5,434.2,520.9,445.4,503.1,441.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_299_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_301_",
    className: "st36",
    d: "M415.2,304.2c-0.3-0.1-0.5-0.2-0.7-0.5c-0.4-0.5-0.2-1.2,0.3-1.6 c0.2-0.2,22.5-15.4,47.2-5.6c0.6,0.2,0.9,0.9,0.7,1.5c-0.2,0.6-0.9,0.9-1.5,0.6c-23.5-9.3-44.8,5.2-45,5.3 C415.8,304.2,415.5,304.2,415.2,304.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_297_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_298_",
    className: "st36",
    d: "M475.6,305.8c-0.1,0-0.2-0.1-0.3-0.1l-7.9-4.1c-0.6-0.3-0.8-1-0.5-1.6 c0.3-0.6,1-0.8,1.6-0.5l7.9,4.1c0.6,0.3,0.8,1,0.5,1.6C476.7,305.7,476.1,305.9,475.6,305.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_295_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_296_",
    className: "st36",
    d: "M562.2,366.9C562.2,366.9,562.2,366.9,562.2,366.9c-0.7-0.2-1-0.8-0.9-1.5 c7.1-24-2.5-34.7-2.5-34.8c-0.4-0.5-0.4-1.2,0.1-1.6c0.5-0.4,1.2-0.4,1.6,0.1c0.4,0.5,10.5,11.7,3.1,37.1 C563.4,366.7,562.8,367,562.2,366.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_282_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_294_",
    className: "st36",
    d: "M532.3,369.5c-0.1,0-0.2-0.1-0.3-0.1c-20.3-10.3-48.2-37.5-48.5-37.7 c-0.5-0.4-0.5-1.2,0-1.6c0.4-0.5,1.2-0.5,1.6,0c0.3,0.3,27.9,27.2,47.9,37.3c0.6,0.3,0.8,1,0.5,1.6 C533.3,369.4,532.8,369.6,532.3,369.5z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Face_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_281_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_300_",
    className: "st36",
    cx: 497.8,
    cy: 374.3,
    r: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_271_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_272_",
    className: "st36",
    cx: 446.8,
    cy: 361.3,
    r: 6.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_279_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_280_",
    className: "st36",
    d: "M468.7,401.9c-5.9-1.3-9.7-7.2-8.4-13.1c0.2-1,1.2-1.6,2.2-1.4c1,0.2,1.6,1.2,1.4,2.2 c-0.9,3.9,1.6,7.9,5.6,8.7c3.9,0.9,7.9-1.6,8.7-5.6c0.2-1,1.2-1.6,2.2-1.4c1,0.2,1.6,1.2,1.4,2.2 C480.5,399.5,474.6,403.2,468.7,401.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_277_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_278_",
    className: "st36",
    d: "M466.1,413.5c-17.2-3.8-29.1-13.7-27.1-22.5c0.2-1,1.2-1.6,2.2-1.4c1,0.2,1.6,1.2,1.4,2.2 c-1.5,6.6,9.7,14.9,24.3,18.1c14.6,3.2,28.2,0.4,29.7-6.2c0.2-1,1.2-1.6,2.2-1.4c1,0.2,1.6,1.2,1.4,2.2 C498.2,413.3,483.3,417.3,466.1,413.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_274_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_275_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_276_",
    className: "st36",
    d: "M429,353.4c-0.1,0-0.2,0-0.2-0.1c-0.9-0.4-1.4-1.4-1.1-2.3c0.1-0.1,5.3-13.8,26.1-9.2 c1,0.2,1.6,1.2,1.4,2.2c-0.2,1-1.2,1.6-2.2,1.4c-17.5-3.9-21.7,6.4-21.8,6.8C430.8,353.1,429.8,353.6,429,353.4z"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Ground"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_411_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_74_",
    className: "st8",
    d: "M46.4,614.8h-22c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4h22c1.3,0,2.4,1.1,2.4,2.4 S47.8,614.8,46.4,614.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_409_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_73_",
    className: "st8",
    d: "M169.6,614.8H57.1c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4h112.6c1.3,0,2.4,1.1,2.4,2.4 S171,614.8,169.6,614.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_407_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_72_",
    className: "st8",
    d: "M194.3,614.8H179c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4h15.3c1.3,0,2.4,1.1,2.4,2.4 S195.6,614.8,194.3,614.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_405_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "st8",
    d: "M329.5,614.8H202.9c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4h126.6c1.3,0,2.4,1.1,2.4,2.4 S330.9,614.8,329.5,614.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_403_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_159_",
    className: "st8",
    d: "M530.7,614.8H341.5c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4h189.2c1.3,0,2.4,1.1,2.4,2.4 S532,614.8,530.7,614.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_401_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_161_",
    className: "st8",
    d: "M586.6,614.8H540c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4h46.6c1.3,0,2.4,1.1,2.4,2.4 S588,614.8,586.6,614.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.687c2d423998508f6fe8c31673b1068e.svg";
export { ForwardRef as ReactComponent };